import React from 'react';
import { Outlet } from 'react-router-dom';
import BackToTop from '../Shared/BackToTop/BackToTop';
import Footer from '../Shared/Footer/Footer';
import HeroNavbar from '../Shared/HeroNavbar/HeroNavbar';
import HomeHeader from '../Shared/HomeHeader/HomeHeader';
import HomeHeaderNew from '../Shared/HomeHeader/HomeHeaderNew';
import NewHomeHeader from '../Shared/HomeHeader/NewHomeHeader';

const Main = () => {
    return (
        <div>
            {/* <HomeHeader/> */}
            <HomeHeaderNew/>
            {/* <NewHomeHeader/> */}
            <HeroNavbar/>
            <BackToTop/>
            <Outlet/>
            <Footer/>
        </div>
    );
};

export default Main;